/**
 * Число?
 * @param {Date} date - дата
 * @return {string}
 */
export const ddmmyyyy = date => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return dd + '.' + mm + '.' + yyyy;
};

export const yyyymmdd = (date, sep = '-') => {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();

    return [
        date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
    ].join(sep);
};

export const addDays = (date, days) => {
    const dateTo = new Date(date);
    dateTo.setDate(dateTo.getDate() + days);
    return dateTo;
};

export const subDays = (date, days) => {
    const dateTo = new Date(date);
    dateTo.setDate(dateTo.getDate() - days + 1);
    return dateTo;
};

export const hhmm = date => {
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');

    return `${hh}:${mm}`;
};

/**
 * Дата, месяц, год строкой
 * @param {Date} date - дата
 * @param {boolean} isGenitive
 * @return {string} дата вида '10 января 2020'
 */
export function ddmmmmyyyy(date, isGenitive = true) {
    if (date instanceof Date) {
        const dd = String(date.getDate()).padStart(2, '0');
        const mmmm = monthString(date, !isGenitive);
        const yyyy = date.getFullYear();

        return dd + ' ' + mmmm + ' ' + yyyy;
    }
    throw Error('аргумент date должен быть экземплятором класса Date');
}

/**
 * Дата, месяц строкой
 * @param {string} date - дата строкой
 * @return {string} дата вида '10 января 2020'
 */
export const ddmm = date => {
    const dateArr = date.split('.');
    const dd = parseInt(dateArr[0], 10);
    const mm = months[parseInt(dateArr[1] - 1)];

    return dd + ' ' + mm;
};

/**
 * @param {Date} date
 * @param {Boolean} padStart
 */
export function ddmmm(date, padStart = true) {
    let dd = date.getDate().toString();
    if (padStart) {
        dd = dd.padStart(2, '0');
    }
    const mmm = months[date.getMonth()];
    return `${dd} ${mmm}`;
}

/**
 * get month string from date
 * @param {Date} date
 * @param {boolean} plain
 */
export const monthString = (date, plain = true) => {
    switch (date.getMonth()) {
        case 0:
            return plain ? 'январь' : 'января';
        case 1:
            return plain ? 'февраль' : 'февраля';
        case 2:
            return plain ? 'март' : 'марта';
        case 3:
            return plain ? 'апрель' : 'апреля';
        case 4:
            return plain ? 'май' : 'мая';
        case 5:
            return plain ? 'июнь' : 'июня';
        case 6:
            return plain ? 'июль' : 'июля';
        case 7:
            return plain ? 'август' : 'августа';
        case 8:
            return plain ? 'сентябрь' : 'сентября';
        case 9:
            return plain ? 'октябрь' : 'октября';
        case 10:
            return plain ? 'ноябрь' : 'ноября';
        case 11:
            return plain ? 'декабрь' : 'декабря';
    }
};

/**
 * @param {Date} date
 * @param {Number} nextMonthCount
 * @param {Boolean} isPlain
 * @returns {string}
 */
export function getMonthName(date, nextMonthCount = 0, isPlain = true) {
    const innerDate = new Date(date);
    if (nextMonthCount > 0) {
        innerDate.setMonth(innerDate.getMonth() + nextMonthCount);
    }
    return monthString(innerDate, isPlain);
}

const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];

/**
 * Месяц в Родительном падеже
 * @param {Number} num - номер месяца начиная с 0
 * @return {string}
 */
export const getNameMonth = num => {
    return months[num];
};

/**
 * Преобразование даты формата 11.12.2019 в формат 2019-12-11 или наоборот
 * @param {string} date - дата в формате 11.12.2019 или 2019-12-11
 * @return {string}
 */
export const formatDate = (date) => {
    // разделитель - тире или точка
    return date.indexOf('-') !== -1
        ? date.split('-').reverse().join('.')
        : date.split('.').reverse().join('-');
};

/**
 * Парсим дату вида "25.06.2020 12:38:30" или "25.06.2020"
 * @param  {string} string
 * @return {Date}
 */
export function parseRusDate(string) {
    //                1        2        3      4  5       6       7
    const regExp = /^(\d{2})\.(\d{2})\.(\d{4})(\s(\d{2}):(\d{2}):(\d{2}))?$/g;
    const matched = regExp.exec(string.trim());

    if (matched == null) {
        throw Error('Некорректная строка c датой');
    }

    if (matched[4] == null) {
        return new Date(Date.UTC(matched[3], +matched[2] - 1, matched[1], 0, 0, 0));
    } else {
        return new Date(Date.UTC(matched[3], +matched[2] - 1, matched[1], matched[5], matched[6], matched[7]));
    }
}

/**
 * Новая дата + count дней
 * @param {number} count
 * @param {Date} date
 * @return {Date}
 */
export function dateNextDay(count, date = new Date()) {
    const now = new Date(date);
    now.setDate(now.getDate() + count);
    return now;
}

/**
 * @param {Date} date
 * @return {string} "2020-12-20"
 */
export function toISODateString(date) {
    return date.toISOString().slice(0, 10);
}

/**
 * Дата вида 2020-02-15 00:00:00 меняется на 2020-02-15T00:00:00 и корректно работает на всех устройствах
 * @param {string} dateString
 * @return {string}
 * */
export function fixDateLikeIsoString(dateString) {
    return dateString && dateString.replace(' ', 'T');
}

/**
 * Выдает последний день месяца
 * @param {Date} date
 * @return {number}
 * */
export const getLastDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

/**
* Количество дней между двумя датами
 * @param {Date} date1
 * @param {Date} date2
 * @return {number}
* */
export const daysBetween = (date1, date2) => {
    console.log(date1, date2);
    return Math.abs(Math.floor((date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24)));
};
